import React from 'react';
import { Button, Tooltip, Tag,Table , Empty} from 'antd';

import TableNivel2 from "./ResultList2";

export default class ResultList1 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    handleSave=() => {

        var item= this.props.dataSource;
        if(item) {}
    }

    render() {
        return (
            <Table
                className={'logistica-table-kardex-almacen'}
                scroll={{ x: true }}
                size="small"
                style={{ overflowX: 'auto' }}
                title={() => (
                    <div style={{ width: '100%', textAlign: "right" }}>
                        <div className="custom-options">
                              {
                                 <Button 
                                 icon="plus"
                                 type="primary"
                                 //loading={this.props.loadingNew}
                                 onClick={this.props.handleNewNivel1}
                               >
                                 Nuevo
                               </Button>
                            }
                        </div>
                    </div>
                )}
                pagination={false}
                dataSource={this.props.dataSource}
                rowKey={record => record.id}
                onExpand={async (expanded, record) => {
                    await this.props.handleSearchNivel1(0,expanded,record);
                }}
                expandedRowRender={(record) => {
                    return (
                        <div style={{ margin: '10px 0px' }}>
                            {
                                <TableNivel2
                                dataSource={record.listaNivel1}
                                handleSearchNivel2={this.props.handleSearchNivel2} 
                                handleSearchNivel3={this.props.handleSearchNivel3} 

                                handleNewNivel2={this.props.handleNewNivel2} 
                                handleNewNivel3={this.props.handleNewNivel3} 
                                />
                            }
                        </div>
                    )
                }}
                locale={{
                    emptyText: <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description='No se encontraron datos.'
                    />
                }}
                columns={[
                    {
                        key: 'options',
                        align: 'center',
                        width: "70px",
                        render: (value, row) => (
                            <div className="custom-options">
                                <Tooltip placement="top" title={"Editar"}>
                                    <Button
                                        type="primary"
                                        icon="edit"
                                        size={"small"}
                                        style={{ display: (row.edit ? 'none' : '') }}
                                        onClick={() => { this.props.handleSearchNivel1(row.id,false,row);}
                                         }
                                    />
                                </Tooltip>
                  
                                <Tooltip placement="top" title={"Cancelar"}>
                                    <Button
                                        icon="close"
                                        size={"small"}
                                        style={{ display: (row.edit ? '' : 'none') }}
                                        onClick={() => this.props.onEdit(0)}
                                    />
                                </Tooltip>
                            </div>
                        )
                    },
                    {
                        title: 'Elemento',
                        dataIndex: 'elemento',
                        key: 'elemento',
                        align: "center"
                    },
                    {
                        title: 'Código Cuenta',
                        dataIndex: 'codigoCuenta',
                        key: 'codigoCuenta',
                        align: "center"
                    },
                    {
                        title: 'Descripción',
                        dataIndex: 'descripcion',
                        key: 'descripcion',
                        align: "center"
                    },
                    {
                        title: 'Tipo Cuenta',
                        dataIndex: 'tipoCuenta',
                        key: 'tipoCuenta',
                        align: "center"
                    },
                    {
                        title: 'OP. Asociada',
                        dataIndex: 'OperacionAsociada',
                        key: 'OperacionAsociada',
                        align: "center"
                    },
               
                ]}
            />
        );
    }
}